module.exports = __webpack_public_path__ + "static/media/1lbg.11f04cf8.pdb";


//////////////////
// WEBPACK FOOTER
// ./src/data/1lbg.pdb
// module id = 190
// module chunks = 0